import { BorderRadiusTokens, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { PhoneNumberDS } from './PhoneNumber';
import { OtpDS } from './Otp';
import { AdditionalDetailsDS } from './additionalDetails';
import { CitySelectionDs } from "./citySelection";
import { isPartnerAffiliated } from "../../configs/utils";
import { ArnDetailsDS } from "./arnDetails";
export const PartnerBodyWeb = (path, partnerName, partnerPhoneNumber, refCode, cityData, referredPartner, metaData, showEmailScreen, termsLink, privacyLink, partnerAccountType, showARNScreen) => {
    const DS = {
        partnerBodyWeb: {
            type: StackType.row,
            height: StackHeight.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                { id: 'leftPaintContainer', type: WIDGET.STACK },
                { id: 'rightPaintContainer', type: WIDGET.STACK },
            ],
        },
        leftPaintContainer: {
            type: StackType.row,
            flex: 1,
            height: StackHeight.MATCH_PARENT,
            bgColor: ColorTokens.Primary_02,
            justifyContent: StackJustifyContent.flexEnd,
            widgetItems: [
                {
                    id: 'leftContentContainer',
                    type: WIDGET.STACK,
                },
            ],
        },
        rightPaintContainer: {
            type: StackType.row,
            height: StackHeight.FULL,
            justifyContent: StackJustifyContent.flexStart,
            flex: 1,
            widgetItems: [
                {
                    id: 'rightContentContainer',
                    type: WIDGET.STACK,
                },
            ],
        },
        leftContentContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            maxWidth: 800,
            padding: {
                right: SizeTypeTokens.XXXXL,
                left: SizeTypeTokens.Size30
            },
            widgetItems: [
                { id: 'partnerReferrerSpace0', type: WIDGET.SPACE },
                { id: 'partnerReferrer', type: WIDGET.PARTNER_SIGNUP_REFERRER },
                { id: 'partnerReferrerSpace1', type: WIDGET.SPACE },
                { id: 'partnerJoinedStack', type: WIDGET.STACK },
                { id: 'partnerReferrerSpace3', type: WIDGET.SPACE },
                { id: 'divider1', type: WIDGET.DIVIDER },
                { id: 'partnerReferrerSpace4', type: WIDGET.SPACE },
                { id: 'partnerBenefit', type: WIDGET.PARTNER_BENEFIT },
                { id: 'partnerReferrerSpace5', type: WIDGET.SPACE },
                { id: 'voltPartner', type: WIDGET.VOLT_PARTNERS },
            ],
        },
        voltPartner: { showPartner: true },
        partnerBenefit: {
            showCard: true,
            type: partnerAccountType
        },
        divider1: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Primary_10,
        },
        partnerJoinedStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            maxWidth: 350,
            bgColor: ColorTokens.Yellow_10,
            borderConfig: {
                borderColor: ColorTokens.Orange_200,
                borderRadius: BorderRadiusTokens.BR1,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: {
                top: SizeTypeTokens.SM,
                bottom: SizeTypeTokens.SM,
                left: SizeTypeTokens.SM,
                right: SizeTypeTokens.SM,
            },
            widgetItems: [
                { id: 'partnerJoinedStackIcon1', type: WIDGET.ICON },
                { id: 'partnerJoinedSpace0', type: WIDGET.SPACE },
                { id: 'partnerJoinedT1', type: WIDGET.TEXT },
            ],
        },
        partnerJoinedT1: {
            label: isPartnerAffiliated(partnerAccountType) ?
                `Over 1,000+ partners trust us` :
                `2000+ Partners have joined Volt Money `,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 16,
        },
        partnerJoinedStackIcon1: {
            name: IconTokens.GoldenThunder,
            size: IconSizeTokens.MD,
        },
        partnerReferrer: {
            isRefCode: partnerName ? true : false,
            partnerName: partnerName ? partnerName : '',
            partnerAccountType: partnerAccountType
        },
        rightContentContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            maxWidth: 800,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'rightContentContainerSpace0', type: WIDGET.SPACE },
                { id: 'signupComponentContainer', type: WIDGET.STACK },
                { id: 'otpComponentContainer', type: WIDGET.STACK },
                { id: 'additionalDetailContainer', type: WIDGET.STACK },
                { id: 'citySelectionContainer', type: WIDGET.STACK },
                { id: 'arnDetailsContainer', type: WIDGET.STACK }
            ],
        },
        ...PhoneNumberDS(path, partnerName, partnerPhoneNumber, showEmailScreen, refCode, referredPartner, termsLink, privacyLink, partnerAccountType, showARNScreen),
        ...OtpDS(partnerPhoneNumber, refCode, referredPartner, partnerAccountType),
        ...AdditionalDetailsDS(cityData, referredPartner, metaData, showEmailScreen, showARNScreen),
        ...ArnDetailsDS(showARNScreen),
        ...CitySelectionDs(cityData),
        partnerReferrerSpace0: {
            size: SizeTypeTokens.XXXXXL,
        },
        partnerReferrerSpace1: {
            size: SizeTypeTokens.XL,
        },
        partnerJoinedSpace0: {
            size: SizeTypeTokens.SM,
        },
        partnerReferrerSpace3: {
            size: SizeTypeTokens.XXXL,
        },
        partnerReferrerSpace4: {
            size: SizeTypeTokens.Size32,
        },
        partnerReferrerSpace5: {
            size: SizeTypeTokens.XXXL,
        },
        rightContentContainerSpace0: {
            size: SizeTypeTokens.XXXXXL,
        },
    };
    return DS;
};
